import { call, options } from './helpers';

export const updateActivity = ({ id, createdAt }) =>
	call(`/beta/activities/${id}`, options({ createdAt }, 'PUT'));

export const deleteActivity = ({ id }) =>
	call(`/beta/activities/${id}`, options(null, 'DELETE'));
